import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SourceCard from './Sources/SourceCard';

export default function SortableItem(props) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const {
    source,
    sources,
    updateSource,
    deleteSourceById,
    updateAndSaveSource,
    infrastructure,
    parameter,
    index,
  } = props;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className="flex w-full mb-1" ref={setNodeRef} style={style}>
      <div
        {...attributes}
        {...listeners}
        className="flex items-center justify-center position-circle relative"
        style={{ width: '20%' }}
      >
        <div className="position-circle-border">
          <div className="position-circle-content">{index + 1}</div>
          <div className="arrow"></div>
        </div>
      </div>
      <div className="flex w-full">
        <SourceCard
          key={source.id}
          source={source}
          sources={sources}
          infrastructure={infrastructure}
          parameter={parameter}
          updateSource={updateSource}
          deleteSourceById={deleteSourceById}
          updateAndSaveSource={updateAndSaveSource}
        />
      </div>
    </div>
  );
}
